module.exports = __webpack_public_path__ + "static/media/icon-user-plus.5047d004.svg";